import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ModeToggle } from '@/components/theme/mode-toggle';
import UserMenu from '@/components/UserMenu';
import { useDesktopNavItems } from './nav-items';

export function TopNav() {
  const location = useLocation();
  const { t } = useTranslation('common');

  const isActive = (path: string, exact?: boolean) =>
    exact ? location.pathname === path : location.pathname.startsWith(path);

  const userNav = useDesktopNavItems();

  return (
    <header className="sticky top-0 z-50 hidden w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 md:block">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-14 items-center justify-between">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex items-center gap-2 font-bold text-lg" aria-label={t('appName')}>
              <img src="/logo.svg" alt={t('appName')} className="h-8 w-8" />
              {t('appName')}
            </Link>
            <nav className="hidden md:flex items-center gap-1">
              {userNav.map((item) => {
                const Icon = item.icon;
                return (
                  <Button
                    key={item.path}
                    variant={isActive(item.path, item.exact) ? 'secondary' : 'ghost'}
                    size="sm"
                    asChild
                  >
                    <Link to={item.path} className="gap-2">
                      <Icon className="h-4 w-4" />
                      {item.label}
                    </Link>
                  </Button>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center gap-2">
            <ModeToggle />
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
}
